import React from 'react';
import useGame from '../hooks/useGame';

// beginning
import beginningLT from '../assets/video/languages/lt/0.beginning.mp4';
import beginningLTMob from '../assets/video/languages/lt/mob/0.beginning.mp4';
import beginningET from '../assets/video/languages/et/0.beginning.mp4';
import beginningETMob from '../assets/video/languages/et/mob/0.beginning.mp4';
import beginningRU from '../assets/video/languages/ru/0.beginning.mp4';
import beginningRUMob from '../assets/video/languages/ru/mob/0.beginning.mp4';
import beginningLV from '../assets/video/languages/lv/0.beginning.mp4';
import beginningLVMob from '../assets/video/languages/lv/mob/0.beginning.mp4';
import beginningLoop from '../assets/video/general/0.beginning_loop.mp4';
import beginningLoopMob from '../assets/video/general/mob/0.beginning_loop.mp4';

// question 1
import question1LT from '../assets/video/languages/lt/1.question.mp4';
import question1LTMob from '../assets/video/languages/lt/mob/1.question.mp4';
import question1ET from '../assets/video/languages/et/1.question.mp4';
import question1ETMob from '../assets/video/languages/et/mob/1.question.mp4';
import question1RU from '../assets/video/languages/ru/1.question.mp4';
import question1RUMob from '../assets/video/languages/ru/mob/1.question.mp4';
import question1LV from '../assets/video/languages/lv/1.question.mp4';
import question1LVMob from '../assets/video/languages/lv/mob/1.question.mp4';
import question1Loop from '../assets/video/general/1.question_loop.mp4';
import question1LoopMob from '../assets/video/general/mob/1.question_loop.mp4';

// question 2
import question2LT from '../assets/video/languages/lt/2.question.mp4';
import question2LTMob from '../assets/video/languages/lt/mob/2.question.mp4';
import question2ET from '../assets/video/languages/et/2.question.mp4';
import question2ETMob from '../assets/video/languages/et/mob/2.question.mp4';
import question2RU from '../assets/video/languages/ru/2.question.mp4';
import question2RUMob from '../assets/video/languages/ru/mob/2.question.mp4';
import question2LV from '../assets/video/languages/lv/2.question.mp4';
import question2LVMob from '../assets/video/languages/lv/mob/2.question.mp4';
import question2Loop from '../assets/video/general/2.question_loop.mp4';
import question2LoopMob from '../assets/video/general/mob/2.question_loop.mp4';

// question 3
import question3LT from '../assets/video/languages/lt/3.question.mp4';
import question3LTMob from '../assets/video/languages/lt/mob/3.question.mp4';
import question3ET from '../assets/video/languages/et/3.question.mp4';
import question3ETMob from '../assets/video/languages/et/mob/3.question.mp4';
import question3RU from '../assets/video/languages/ru/3.question.mp4';
import question3RUMob from '../assets/video/languages/ru/mob/3.question.mp4';
import question3LV from '../assets/video/languages/lv/3.question.mp4';
import question3LVMob from '../assets/video/languages/lv/mob/3.question.mp4';
import question3Loop from '../assets/video/general/3.question_loop.mp4';
import question3LoopMob from '../assets/video/general/mob/3.question_loop.mp4';

// question 4
import question4LT from '../assets/video/languages/lt/4.question.mp4';
import question4LTMob from '../assets/video/languages/lt/mob/4.question.mp4';
import question4ET from '../assets/video/languages/et/4.question.mp4';
import question4ETMob from '../assets/video/languages/et/mob/4.question.mp4';
import question4RU from '../assets/video/languages/ru/4.question.mp4';
import question4RUMob from '../assets/video/languages/ru/mob/4.question.mp4';
import question4LV from '../assets/video/languages/lv/4.question.mp4';
import question4LVMob from '../assets/video/languages/lv/mob/4.question.mp4';
import question4Loop from '../assets/video/general/4.question_loop.mp4';
import question4LoopMob from '../assets/video/general/mob/4.question_loop.mp4';

// question 5
import question5LT from '../assets/video/languages/lt/5.question.mp4';
import question5LTMob from '../assets/video/languages/lt/mob/5.question.mp4';
import question5ET from '../assets/video/languages/et/5.question.mp4';
import question5ETMob from '../assets/video/languages/et/mob/5.question.mp4';
import question5RU from '../assets/video/languages/ru/5.question.mp4';
import question5RUMob from '../assets/video/languages/ru/mob/5.question.mp4';
import question5LV from '../assets/video/languages/lv/5.question.mp4';
import question5LVMob from '../assets/video/languages/lv/mob/5.question.mp4';
import question5Loop from '../assets/video/general/5.question_loop.mp4';
import question5LoopMob from '../assets/video/general/mob/5.question_loop.mp4';

// question 6
import question6LT from '../assets/video/languages/lt/6.question.mp4';
import question6LTMob from '../assets/video/languages/lt/mob/6.question.mp4';
import question6ET from '../assets/video/languages/et/6.question.mp4';
import question6ETMob from '../assets/video/languages/et/mob/6.question.mp4';
import question6RU from '../assets/video/languages/ru/6.question.mp4';
import question6RUMob from '../assets/video/languages/ru/mob/6.question.mp4';
import question6LV from '../assets/video/languages/lv/6.question.mp4';
import question6LVMob from '../assets/video/languages/lv/mob/6.question.mp4';
import question6Loop from '../assets/video/general/6.question_loop.mp4';
import question6LoopMob from '../assets/video/general/mob/6.question_loop.mp4';

// question 7
import question7LT from '../assets/video/languages/lt/7.question.mp4';
import question7LTMob from '../assets/video/languages/lt/mob/7.question.mp4';
import question7ET from '../assets/video/languages/et/7.question.mp4';
import question7ETMob from '../assets/video/languages/et/mob/7.question.mp4';
import question7RU from '../assets/video/languages/ru/7.question.mp4';
import question7RUMob from '../assets/video/languages/ru/mob/7.question.mp4';
import question7LV from '../assets/video/languages/lv/7.question.mp4';
import question7LVMob from '../assets/video/languages/lv/mob/7.question.mp4';
import question7Loop from '../assets/video/general/7.question_loop.mp4';
import question7LoopMob from '../assets/video/general/mob/7.question_loop.mp4';

// question 8
import question8LT from '../assets/video/languages/lt/8.question.mp4';
import question8LTMob from '../assets/video/languages/lt/mob/8.question.mp4';
import question8ET from '../assets/video/languages/et/8.question.mp4';
import question8ETMob from '../assets/video/languages/et/mob/8.question.mp4';
import question8RU from '../assets/video/languages/ru/8.question.mp4';
import question8RUMob from '../assets/video/languages/ru/mob/8.question.mp4';
import question8LV from '../assets/video/languages/lv/8.question.mp4';
import question8LVMob from '../assets/video/languages/lv/mob/8.question.mp4';
import question8Loop from '../assets/video/general/8.question_loop.mp4';
import question8LoopMob from '../assets/video/general/mob/8.question_loop.mp4';

// question 9
import question9LT from '../assets/video/languages/lt/9.question.mp4';
import question9LTMob from '../assets/video/languages/lt/mob/9.question.mp4';
import question9ET from '../assets/video/languages/et/9.question.mp4';
import question9ETMob from '../assets/video/languages/et/mob/9.question.mp4';
import question9RU from '../assets/video/languages/ru/9.question.mp4';
import question9RUMob from '../assets/video/languages/ru/mob/9.question.mp4';
import question9LV from '../assets/video/languages/lv/9.question.mp4';
import question9LVMob from '../assets/video/languages/lv/mob/9.question.mp4';
import question9Loop from '../assets/video/general/9.question_loop.mp4';
import question9LoopMob from '../assets/video/general/mob/9.question_loop.mp4';

// question 10
import question10LT from '../assets/video/languages/lt/10.question.mp4';
import question10LTMob from '../assets/video/languages/lt/mob/10.question.mp4';
import question10ET from '../assets/video/languages/et/10.question.mp4';
import question10ETMob from '../assets/video/languages/et/mob/10.question.mp4';
import question10RU from '../assets/video/languages/ru/10.question.mp4';
import question10RUMob from '../assets/video/languages/ru/mob/10.question.mp4';
import question10LV from '../assets/video/languages/lv/10.question.mp4';
import question10LVMob from '../assets/video/languages/lv/mob/10.question.mp4';
import question10Loop from '../assets/video/general/10.question_loop.mp4';
import question10LoopMob from '../assets/video/general/mob/10.question_loop.mp4';

// end
import endLT from '../assets/video/languages/lt/11.final.mp4';
import endLTMob from '../assets/video/languages/lt/mob/11.final.mp4';
import endET from '../assets/video/languages/et/11.final.mp4';
import endETMob from '../assets/video/languages/et/mob/11.final.mp4';
import endRU from '../assets/video/languages/ru/11.final.mp4';
import endRUMob from '../assets/video/languages/ru/mob/11.final.mp4';
import endLV from '../assets/video/languages/lv/11.final.mp4';
import endLVMob from '../assets/video/languages/lv/mob/11.final.mp4';
import endLoop from '../assets/video/general/12.score.mp4';
import endLoopMob from '../assets/video/general/mob/12.score.mp4';
import { usePageVisibility } from 'react-page-visibility';


const loopVideos = {
  desktop: {
    intro: beginningLoop,
    q1: question1Loop,
    q2: question2Loop,
    q3: question3Loop,
    q4: question4Loop,
    q5: question5Loop,
    q6: question6Loop,
    q7: question7Loop,
    q8: question8Loop,
    q9: question9Loop,
    q10: question10Loop,
    end: endLoop,
  },
  mobile: {
    intro: beginningLoopMob,
    q1: question1LoopMob,
    q2: question2LoopMob,
    q3: question3LoopMob,
    q4: question4LoopMob,
    q5: question5LoopMob,
    q6: question6LoopMob,
    q7: question7LoopMob,
    q8: question8LoopMob,
    q9: question9LoopMob,
    q10: question10LoopMob,
    end: endLoopMob,
  }
};

const languageVideos = {
  desktop: {
    intro: {
      et: beginningET,
      lt: beginningLT,
      lv: beginningLV,
      ru: beginningRU,
    },
    q1: {
      et: question1ET,
      lt: question1LT,
      lv: question1LV,
      ru: question1RU,
    },
    q2: {
      et: question2ET,
      lt: question2LT,
      lv: question2LV,
      ru: question2RU,

    },
    q3: {
      et: question3ET,
      lt: question3LT,
      lv: question3LV,
      ru: question3RU,
    },
    q4: {
      et: question4ET,
      lt: question4LT,
      lv: question4LV,
      ru: question4RU,
    },
    q5: {
      et: question5ET,
      lt: question5LT,
      lv: question5LV,
      ru: question5RU,
    },
    q6: {
      et: question6ET,
      lt: question6LT,
      lv: question6LV,
      ru: question6RU,
    },
    q7: {
      et: question7ET,
      lt: question7LT,
      lv: question7LV,
      ru: question7RU,
    },
    q8: {
      et: question8ET,
      lt: question8LT,
      lv: question8LV,
      ru: question8RU,
    },
    q9: {
      et: question9ET,
      lt: question9LT,
      lv: question9LV,
      ru: question9RU,
    },
    q10: {
      et: question10ET,
      lt: question10LT,
      lv: question10LV,
      ru: question10RU,
    },
    end: {
      et: endET,
      lt: endLT,
      lv: endLV,
      ru: endRU,
    }
  },
  mobile: {
    intro: {
      et: beginningETMob,
      lt: beginningLTMob,
      lv: beginningLVMob,
      ru: beginningRUMob,
    },
    q1: {
      et: question1ETMob,
      lt: question1LTMob,
      lv: question1LVMob,
      ru: question1RUMob,
    },
    q2: {
      et: question2ETMob,
      lt: question2LTMob,
      lv: question2LVMob,
      ru: question2RUMob,

    },
    q3: {
      et: question3ETMob,
      lt: question3LTMob,
      lv: question3LVMob,
      ru: question3RUMob,
    },
    q4: {
      et: question4ETMob,
      lt: question4LTMob,
      lv: question4LVMob,
      ru: question4RUMob,
    },
    q5: {
      et: question5ETMob,
      lt: question5LTMob,
      lv: question5LVMob,
      ru: question5RUMob,
    },
    q6: {
      et: question6ETMob,
      lt: question6LTMob,
      lv: question6LVMob,
      ru: question6RUMob,
    },
    q7: {
      et: question7ETMob,
      lt: question7LTMob,
      lv: question7LVMob,
      ru: question7RUMob,
    },
    q8: {
      et: question8ETMob,
      lt: question8LTMob,
      lv: question8LVMob,
      ru: question8RUMob,
    },
    q9: {
      et: question9ETMob,
      lt: question9LTMob,
      lv: question9LVMob,
      ru: question9RUMob,
    },
    q10: {
      et: question10ETMob,
      lt: question10LTMob,
      lv: question10LVMob,
      ru: question10RUMob,
    },
    end: {
      et: endETMob,
      lt: endLTMob,
      lv: endLVMob,
      ru: endRUMob,
    }
  }
};

const VideoFilesFullLoop = ({page, id, showLoop = true, showFull = true}) => {
  const isVisible = usePageVisibility();
  const {language, isPlayingBackgroundMusic} = useGame();

  const videoFullDesktop = languageVideos.desktop[page][language];
  const videoFullMobile = languageVideos.mobile[page][language];
  const videoLoopDesktop = loopVideos.desktop[page];
  const videoLoopMobile = loopVideos.mobile[page];

  // autoplay is on, except for intro
  let autoplay = true;
  let className = "bg-video full qv"

  if (page === "intro") {
    autoplay = false;
    className = "bg-video full"
  }

  const isMobile = window.innerWidth < 769;

  let muted = false;

  if(!isVisible || !isPlayingBackgroundMusic){
    muted = true;
  }

  // const videoFull = window.innerWidth < 769 ? videoFullMobile : videoFullDesktop;
  // const videoLoop = window.innerWidth < 769 ? videoLoopMobile : videoLoopDesktop;

  // return (
  //   <>
  //     {showFull && (
  //       <div dangerouslySetInnerHTML={{
  //         __html: `<video
  //           muted
  //           autoplay
  //           playsinline
  //           preload="metadata"
  //           id="${id}"
  //           class="${className}"
  //           >
  //               <source src="${videoFull}" type="video/mp4" />
  //           </video>`
  //       }} />
  //     )}
  //     {showLoop && (
  //       <div dangerouslySetInnerHTML={{
  //         __html: `<video
  //           loop
  //           muted
  //           autoplay
  //           playsinline
  //           preload="metadata"
  //           id="${id}-loop"
  //           class="bg-video loop"
  //           >
  //               <source src="${videoLoop}" type="video/mp4" />
  //           </video>`
  //       }} />
  //     )}
  //   </>
  // )


  if(isMobile){
    // console.log('in here?')

    // console.log('srcmob 1 ', vi)
    return (
      <>
        {showFull && (
          <video tabIndex={-1} muted={muted} playsInline preload="metadata" id={id}
                 className={className} srcdesk={videoFullDesktop} srcmob={videoFullMobile}/>
        )}
        {showLoop && page === "intro" && (
          <video tabIndex={-1} muted={muted} loop playsInline preload="metadata" id={`${id}-loop`}
                 className="bg-video loop" srcdesk={videoLoopDesktop} srcmob={videoLoopMobile}/>
        )}
      </>
    )
  }

  return (
    <>
      {showFull && (
        <video tabIndex={-1} autoPlay={autoplay} muted={muted} playsInline preload="metadata" id={id}
               className={className} srcdesk={videoFullDesktop} srcmob={videoFullMobile}/>
      )}
      {showLoop && (
        <video tabIndex={-1} muted={muted} loop playsInline preload="metadata" id={`${id}-loop`}
               className="bg-video loop" srcdesk={videoLoopDesktop} srcmob={videoLoopMobile}/>
      )}
    </>
  );

};

export default VideoFilesFullLoop;

